import is from "is_js";

const isMobile = is.mobile();

const darkBackground = {
  zIndex: "999",
  opacity: "0.6",
  position: "static",
  display: "none",
  left: "0px",
  top: "0px",
  bottom: "0px",
  right: "0px",
  border: "0px",
  // overflow: "visible",
  backgroundColor: "rgba(255,0,255, 0.6)",
};

const div_frame = {
  height: "100%",
  width: "100%",
  position: "static",
  zIndex: "999",
  border: "0px",
  fontSize: "16px",
};

const closeButton = {
  display: "none",
  top: "1%",
  width: "48px",
  height: "32px",
  right: "1%",
  background:
    'url("https://securepay.tinkoff.ru/html/payForm/img/close-button.png") no-repeat',
  position: "absolute",
  zIndex: "999",
  cursor: "pointer",
  border: "none",
  visibility: "visible",
};

const payFormIframe = {
  width: "100%",
  height: isMobile ? "90%" : "100%",
  border: "none",
  borderRadius: "5px",
  fontSize: "16px",
};
const payFormContainer = {
  position: "relative",
  zIndex: "999",
  height: "100%",
  width: "100%",
  fontSize: "16px",
};
const style = {
  payFormContainer,
  darkBackground,
  div_frame,
  closeButton,
  payFormIframe,
};

export default style;
